import axios from 'axios'
import { mapActions, mapGetters } from 'vuex'
export default {
    data() {
        return {
            loading: false,
            isBusy: false,
            currentPage: 1,
            offset: 0,
            pageSize: process.env.VUE_APP_PAGINATION_PAGE_SIZE,
            sortColumn: "TEST_NUMBER",
            sortType: "DESCENDING",
            sortBySync: "testNumber",
            sortDesc: true
        }
    },
    computed: {
        ...mapGetters({
            organisationId: 'UserStore/GetUserOrganisationId',
            isTrial: 'OrganisationStore/GetIsTrial',
            facilityId: 'UserStore/GetUserFacilityId',
            patientIdentifierLabel: 'OrganisationStore/GetPatientIdentifierLabel',
            results: 'SearchStore/GetResults',
            patientText: 'SearchStore/GetPatientText',
            hasSearchBeenExecuted: 'SearchStore/GetHasSearchBeenExecuted'
        }),

        filteredTestsFields() {
            if(this.isTrial) {
                return [
                    {
                        key: 'testNumber',
                        label: 'Test Number',
                        sortable: true
                    },
                    {
                        key: 'patientName',
                        label: 'Patient name',
                        variant: 'text-wrap w-15',
                        sortable: true,
                    },
                    {
                        key: 'patientIdentifier',
                        label: this.patientIdentifierLabel,
                        sortable: true,
                    },
                    {
                        key: 'deviceNumber',
                        label: 'Device Number',
                        sortable: true
                    },
                    {
                        key: 'patientDOB',
                        label: 'DOB',
                        sortable: true,
                        formatter: 'formatDate'
                    },
                    {
                        key: 'patientPostalCode',
                        label: 'Postcode',
                        sortable: true,
                    },
                    {
                        key: 'issuedDate',
                        label: 'Issue Date',
                        sortable: true,
                        formatter: 'formatDate'
                    },
                    {
                        key: 'returnDate',
                        label: 'Return date',
                        sortable: true,
                        formatter: 'formatDate'
                    },
                    {
                        key: 'dueDate',
                        label: 'Test date',
                        sortable: true,
                        formatter: 'formatDate'
                    },
                    {
                        key: 'gdEstimatedDeliveryDate',
                        label: 'EDD',
                        sortable: true,
                        formatter: 'formatDate'
                    },
                    {
                        key: 'status',
                        label: 'Status',
                        sortable: true
                    },
                    {
                        key: 'practitionerName',
                        label: 'Assigned HCP',
                        variant: 'text-wrap w-15',
                        sortable: true,
                    },
                    {
                        key: 'facilityName',
                        label: 'Facility',
                        sortable: true,
                    },
                    {
                        key: 'dateUpdated',
                        label: 'Last Updated',
                        variant: 'text-wrap w-15',
                        formatter: 'formatDate',
                        sortable: true
                    },
                    {
                        key: 'action',
                        label: ''
                    }
                ]
            }

            return [
                {
                    key: 'testNumber',
                    label: 'Test NO',
                    sortable: true
                },
                {
                    key: 'patientName',
                    label: 'Patient name',
                    variant: 'text-wrap w-15',
                    sortable: true,
                },
                {
                    key: 'patientIdentifier',
                    label: this.patientIdentifierLabel,
                    sortable: true,
                },
                {
                    key: 'patientDOB',
                    label: 'DOB',
                    sortable: true,
                    formatter: 'formatDate'
                },
                {
                    key: 'patientPostalCode',
                    label: 'Location',
                    sortable: true,
                },
                {
                    key: 'issuedDate',
                    label: 'Issue Date',
                    sortable: true,
                    formatter: 'formatDate'
                },
                {
                    key: 'returnDate',
                    label: 'Return date',
                    sortable: true,
                    formatter: 'formatDate'
                },
                {
                    key: 'dueDate',
                    label: 'Test date',
                    sortable: true,
                    formatter: 'formatDate'
                },
                {
                    key: 'gdEstimatedDeliveryDate',
                    label: 'EDD',
                    sortable: true,
                    formatter: 'formatDate'
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true
                },
                {
                    key: 'practitionerName',
                    label: 'Assigned HCP',
                    variant: 'text-wrap w-15',
                    sortable: true,
                },
                {
                    key: 'facilityName',
                    label: 'Facility',
                    sortable: true,
                },
                {
                    key: 'dateUpdated',
                    label: 'Last Updated',
                    variant: 'text-wrap w-15',
                    formatter: 'formatDate',
                    sortable: true
                },
                {
                    key: 'action',
                    label: ''
                }
            ]
        }
    },

    methods: {
        ...mapActions({
            setSearchbarDataInSearchStore: 'SearchStore/SetSearchbarData',
            setNotification: 'NotificationStore/SetNotification'
        }),

        async getResults() {
            this.isBusy = true

            let searchModel = {
                organisationId: this.organisationId,
                pageSize: this.pageSize,
                patientText: this.patientText,
                offset: this.offset,
                sortColumn: this.sortColumn,
                sortType: this.sortType
            }

            try {
                let response = await axios.post(`${process.env.VUE_APP_AXIOS_DIAGNOSTIC_BASE_URL}/api/v1/tests/search`, searchModel)
            
                this.setSearchbarDataInSearchStore({
                    results: response.data, 
                    patientText: this.patientText
                })
            }
            catch(err) {
                this.setNotification({
                    type: 'error',
                    title: 'Error',
                    message: 'Something went wrong. Please try again'
                })
            }
            finally {
                this.loading = false
                this.isBusy = false
                this.$emit('loadingFinished')
            }
        },

        sortingChanged(e) {
            switch(e.sortBy) {
                case 'patientName':
                    this.sortColumn = 'PATIENT_NAME'
                break;

                case 'testNumber':
                    this.sortColumn = 'TEST_NUMBER'
                break;

                case 'patientIdentifier':
                    this.sortColumn = 'PATIENT_IDENTIFIER'
                break;

                case 'deviceNumber':
                    this.sortColumn = 'DEVICE_NUMBER'
                break;

                case 'patientDOB':
                    this.sortColumn = 'PATIENT_DOB'
                break;

                case 'patientPostalCode':
                    this.sortColumn = 'POSTCODE'
                break;

                case 'issuedDate':
                    this.sortColumn = 'ISSUED_DATE'
                break;

                case 'returnDate':
                    this.sortColumn = 'RETURN_DATE'
                break;

                case 'dueDate':
                    this.sortColumn = 'DUE_DATE'
                break;

                case 'gdEstimatedDeliveryDate':
                    this.sortColumn = 'EDD'
                break;

                case 'status':
                    this.sortColumn = 'STATUS'
                break;

                case 'practitionerName':
                    this.sortColumn = 'PRACTITIONER_NAME'
                break;

                case 'facilityName':
                    this.sortColumn = 'FACILITY_NAME'
                break;

                case 'dateUpdated':
                    this.sortColumn = 'LAST_UPDATED_DATE'
                break
            }

            this.sortDesc = e.sortDesc

            if(this.sortDesc) {
                this.sortType = 'DESCENDING'
            } else {
                this.sortType = 'ASCENDING'
            }

            this.getResults()
        },

        pageChange(value) {        
            this.currentPage = value, 
            this.offset = (value - 1) * this.results.pageSize
            this.getResults()
        },

        refreshTable () {
            this.$refs.table.refresh()
        },
    }
}